// extracted by mini-css-extract-plugin
export var fileUpload = "_f8-1";
export var modalButton = "_f8-0";